import cookies from 'js-cookie';

const useToken = () => {
  return cookies.get('csrftoken') || '';
};

export default useToken;
